import axiosInst from '../../libs/axios/axios'
const moment = require('moment-timezone')

const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL,
  timeOut: process.env.VUE_APP_TIME_OUT,
  regularHivesData: {
    all: [],
    hiveIdList: []
  },
  filters: {
    user:null,
    apiary:null
  },
  hive:null,
  newHive:null
}
const getters = {
  returnHivesData (state) {
    return state.regularHivesData
  },
  hiveFilters (state) {
    return state.filters
  },
  hiveData (state) {
    return state.hive
  },
  newHiveData (state) {
    return state.newHive
  }
}
const mutations = {
  hive (state, info) {
    state.hive = info
  },
  newHive (state, info) {
    state.newHive = info
  },
  filters (state, info) {
    if (info.type === 'apiary') {
      state.filters.apiary = info.data
    }
    if (info.type === 'user') {
      state.filters.user = info.data
    }
  },
  clearRegularHivesData (state) {
    state.regularHivesData = {
      all: [],
      hiveIdList: []
    }
  },
  regularHivesDataUpdate (state, info) {
    if (info.length > 0) {
      info.map((value) => {
        state.regularHivesData.all.push({
          'name': value.name,
          'is_hive': !!((value.device && value.device.device_serial)),
          'device_serial': (value.device && value.device.device_serial) ? value.device.device_serial : null,
          'id': value.id,
          'bee_type':value.bee_type,
          'temp': (value.latest_data && value.latest_data.temp) ? value.latest_data.temp : null,
          'hum': (value.latest_data && value.latest_data.hum) ? value.latest_data.hum : null,
          'battery':(value.latest_data && value.latest_data.battery && value.latest_data.battery !== '-')  ? parseFloat(value.latest_data.battery) : null,
          'weight':(value.latest_data && value.latest_data.weight) ? value.latest_data.weight : null,
          'signal': (value.latest_data && value.latest_data.signal && value.latest_data.signal !== '-')  ? parseFloat(value.latest_data.signal) : null,
          'alarm': value.has_alarm,
          'timestampms': value.latest_data && value.latest_data.timestamp ? moment(value.latest_data.timestamp).tz('Europe/Istanbul').fromNow() : '--',
          'apiary': value.apiary ? value.apiary.name : '--',
          'device': value.device,
          'user': value.user,
          'hive_type': value.hive_type
        })

        state.regularHivesData.hiveIdList.push(value.id)
      })

    } else {
      state.regularHivesData = {
        all: [],
        hiveIdList: []
      }
    }
  },
  hiveDataUpdate (state, info) {
    const deviceList = state.regularHivesData.all
    const deviceIndex = deviceList.findIndex((p) => {
      return p.id === info.id
    })
    if (deviceIndex !== -1) {
      deviceList[deviceIndex].temp = info.temp
      deviceList[deviceIndex].hum = info.hum
      deviceList[deviceIndex].weight = info.weight
      deviceList[deviceIndex].alarm = info.alarm
      deviceList[deviceIndex].timestampms = info.timestampms === null ? '--' : moment(info.timestampms).tz('Europe/Istanbul').fromNow()
      deviceList[deviceIndex].battery = info.battery !== '-' && info.battery !== null ? parseFloat(info.battery) : null
      deviceList[deviceIndex].signal = info.signal !== '-' && info.signal !== null ? parseFloat(info.signal) : null 
    }
  }

}
const actions = {
  getHiveFilters (store, filters) {
    store.commit('filters', filters)
  },
  getNewHiveData (store, hive) {
    store.commit('newHive', hive)
  },
  getHivesData (store, params) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/${  params}`).then(response => {
        store.commit('clearRegularHivesData')

        if (response.data.results.length) {
          store.commit('regularHivesDataUpdate', response.data.results)
        } else {
          store.commit('regularHivesDataUpdate', [])
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getLastHiveDatas (store) {
    try {
      const lastDataArray = state.regularHivesData.hiveIdList.map(async id => {
        const response = await axiosInst.get(`${state.rootUrl  }/api/hives/${  id  }/data`)
        const latestData = response.data.latest_data
        const data = {
          id:response.data.id,
          temp: latestData && latestData.temp ? latestData.temp : null,
          hum: latestData && latestData.hum ? latestData.hum : null,
          weight: latestData && latestData.weight ? latestData.weight : null,
          alarm: response.data.has_alarm,
          timestampms: latestData && latestData.timestamp ? Number(latestData.timestamp) : null,
          battery: latestData && latestData.battery ? latestData.battery : null,
          signal: latestData && latestData.signal ? latestData.signal : null,
          deviceserial: latestData && latestData.device_identifier ? latestData.device_identifier : '--'
        }

        store.commit('hiveDataUpdate', data)
        return response
      })
      await Promise.all(lastDataArray)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getHivesLazyLoadData (store, api) {
    return new Promise((resolve, reject) => {
      axiosInst.get(api).then(response => {
        if (response.data.results.length) {
          store.commit('regularHivesDataUpdate', response.data.results)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHive (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/${  data.id  }/`).then(response => {
        store.commit('hive', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  hiveStatistics (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/${  data.id  }/statistics/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBeeType () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/bees/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getHiveType () {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/hives/types/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  createHive (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.post(`${state.rootUrl  }/api/hives/`, data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  editHive (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/hives/${  data.id  }/`, data.data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteHive (store, data) {
    return new Promise((resolve, reject) => {
      axiosInst.delete(`${state.rootUrl  }/api/hives/${  data.id  }/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  rentalKeyCheck (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.get(`${state.rootUrl  }/api/rental/${  info  }/check/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  rentalAgreement (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/rental/${  info.rent_customer_key  }/agreement/`, info.data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  rentalConfirm (store, info) {
    return new Promise((resolve, reject) => {
      axiosInst.put(`${state.rootUrl  }/api/rental/${  info  }/confirm/`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  state,
  getters,
  mutations,
  actions
}
